import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import './index.css';
import { ProgramProvider } from './Contexts/ProgramContext';
import { CalendarProvider } from './Contexts/CalendarContext';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <Router>
      <ProgramProvider>
          <CalendarProvider>
            <App />
          </CalendarProvider>
        </ProgramProvider>
    </Router>
);
